<template>
  <div v-if="show" class="toTop" @click="toTop">
    <svg
      aria-hidden="true"
      role="presentation"
      focusable="false"
      viewBox="0 0 24 24"
      class="q-icon notranslate"
      style="width: 16px; height: 16px"
    >
      <use xlink:href="#icon-backtotop" />
    </svg>
  </div>
</template>

<script>
import { scroll } from 'quasar';

const { setScrollPosition } = scroll;

export default {
  // eslint-disable-next-line vue/require-prop-types
  props: ['target'],
  data() {
    return {
      show: false,
    };
  },
  watch: {
    target() {
      this.$nextTick(() => {
        this.target?.removeEventListener('scroll', this.onScroll, false);
        this.target?.addEventListener('scroll', this.onScroll, false);
      });
    },
  },
  beforeDestroy() {
    this.target?.removeEventListener('scroll', this.onScroll);
  },
  methods: {
    toTop() {
      setScrollPosition(this.target, 0, 300);
    },
    onScroll(e) {
      this.show = e.target.scrollTop > 300;
    },
  },
};
</script>

<style lang="scss">
.toTop {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  filter: drop-shadow(0px 4px 4px rgba(0, 0, 0, 0.04));
  background: #fff;
  display: grid;
  place-items: center;
  position: absolute;
  z-index: 999;
  bottom: 100px;
  right: 8px;
}
</style>
